(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[56012,7797,5783,75978,91058,99257,68837,33030],{

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ })

}]);